<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div>
    <br> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- {{leave_approval_hierarchy_list}} -->
    <v-data-table :headers="headers" :items="leave_approval_hierarchy_list" class="elevation-1" :search="search">

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Leave Approval Hierarchy</v-toolbar-title>

          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="mb-2 button" v-on="on">Add Leave Approval Hierarchy</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.level" persistent-hint
                          :hint="editedIndex==-1?'For example :: 1,2,3':'For example :: 1,2,3'" label="Enter Level No"
                          :rules="[v => !!v || 'required']" type="number" rounded outlined dense>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.approval_period_days" persistent-hint
                          :hint="editedIndex==-1?'For example :: 1,2,3':'For example :: 1,2,3'"
                          label="Enter Approval Period Days" :rules="[v => !!v || 'required']" type="number" rounded
                          outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-autocomplete rounded outlined dense v-model="editedItem.leavetypeId" :items="leave_type_list"
                          :rules="[v => !!v || 'required']" item-text="type" item-value="id" label="Leave Type"
                          :filled="editedIndex==-1?false:true" single-line></v-autocomplete>
                      </v-col>

                      <v-col cols="12">
                        <v-autocomplete rounded outlined dense v-model="editedItem.leaveapporvalauthorityId"
                          :items="leave_approval_authority_list" :rules="[v => !!v || 'required']" item-text="authority"
                          item-value="id" label="Leave Approval Authority" :filled="editedIndex==-1?false:true"
                          single-line></v-autocomplete>
                      </v-col>

                      <v-col cols="10">
                        <v-checkbox v-model="editedItem.is_last_approval" color="success" label="Is Last?"></v-checkbox>
                      </v-col>

                      <v-col cols="10">
                        <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>


      <template v-slot:item.is_last_approval="{ item }">
        <span v-if="item.is_last_approval">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>

      </template>

    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      valid: false,
      // extraBreadcrumbItems: [
      //   { text: "Leave Approval Hierarchy", disabled: true, href: "" },

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      overlay:false,
    errorMsg: {
      castId: false
    },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Sr No',
          align: 'left',
          sortable: true,
          value: 'srno',
        }, 
        {
          text: 'Level No',
          align: 'left',
          sortable: true,
          value: 'level',
        },           
        {
          text: 'Leave Type',
          align: 'left',
          sortable: true,
          value: 'leavetypename',
        },  
        {
          text: 'Leave Approval Authority',
          align: 'left',
          sortable: true,
          value: 'leaveapporvalauthorityname',
        },  
        {
          text: 'Approval Period Days',
          align: 'left',
          sortable: false,
          value: 'approval_period_days',
        }, 
        {
          text: 'Is Last Approved?',
          align: 'left',
          sortable: true,
          value: 'is_last_approval',
        },      
        {
          text: 'Is Active?',
          align: 'left',
          sortable: true,
          value: 'isactive',
        },   
        { text: 'Actions', value: 'action', sortable: false },
      ],
      leave_approval_hierarchy_list: [],
      leave_type_list:[],
      leave_approval_authority_list:[],
      editedIndex: -1,
      editedItem: {
        leaveApprovalHierarchyId: '',
        level: '',      
        approval_period_days:'' ,    
        isActive:true,  
        is_last_approval:false,  
        leavetypeId:'',
        leaveapporvalauthorityId:''
      },
      defaultItem: {
        leaveApprovalHierarchyId: '',
        level: '',      
        approval_period_days:'' ,    
        isActive:true,  
        is_last_approval:false,   
        leavetypeId:'',
        leaveapporvalauthorityId:''         
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Leave Approval Hierarchy' : 'Edit Leave Approval Hierarchy'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },
    mounted(){
      this.onLoad()       
     },
    methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad(){      
      this.overlay=true;
          axios
      .post("/LeaveManagement/getLeaveApprovalHierarchyList")
      .then(res => {
        if (res.data.msg == "200") {
          if(this.load = true){
            this.overlay=false;
            this.leave_approval_hierarchy_list = res.data.leave_approval_hierarchy_list;
            this.leave_type_list = res.data.leave_type_list;
            this.leave_approval_authority_list = res.data.leave_approval_authority_list;           
          }
        } else {
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log("Errro------>"+error);
      })
      .finally(()=>{ 
        var overlay=false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem (item) {
        this.editedIndex = this.leave_approval_hierarchy_list.indexOf(item)        
        this.dialog = true
        this.editedItem.level = item.level.toString()   
        this.editedItem.approval_period_days = item.approval_period_days.toString()
        this.editedItem.isActive = item.isactive
        this.editedItem.leaveApprovalHierarchyId = item.id
        this.editedItem.is_last_approval = item.is_last_approval
        this.editedItem.leavetypeId = item.leavetypeid
        this.editedItem.leaveapporvalauthorityId = item.leaveapporvalauthorityid    
    },

      // deleteItem (item) {
      //   const index = this.language_super_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save() {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/LeaveManagement/editLeaveApprovalHierarchy", this.editedItem)
              .then(res => {               
                if (res.data.status.code == "SUCCESS") {                 
                  this.showSnackbar(
                    "#4caf50",
                    "Leave Approval Hierarchy Updated Successfully..."
                  ); // show snackbar on success
                  this.onLoad();
                }
                else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Leave Approval Hierarchy Already Present!!!"); // show snackbar on error
                  this.onLoad();
                }
                else if (res.data.status.code == "ILA") {
                  this.showSnackbar("#b71c1c", res.data.status.msg); // show snackbar on error
                  this.onLoad();
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close();
          }
        } else {         
            axios
              .post("/LeaveManagement/saveLeaveApprovalHierarchy", this.editedItem)
              .then(res => {
                if (res.data.status.code == "SUCCESS") {                  
                  this.leave_approval_hierarchy_list.push(this.editedItem);
                  this.showSnackbar("#4caf50", "Leave Approval Hierarchy Added Successfully..."); // show snackbar on success
                  this.onLoad()
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Leave Approval Hierarchy Already Present!!!"); // show snackbar on error
                }
              })
              .catch(error => {
                window.console.log(error);
              });

            this.close(); 
        }
      }, // end of save()

      isValidated() {
        if (this.editedItem.leaveApprovalHierarchyId) {
          return true;
        } else {
          if (!this.editedItem.leaveApprovalHierarchyId) {
            this.errorMsg.leaveApprovalHierarchyId = true;
          }

          return false;
        }
      } // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>